<template>
  <hooper id="hooperContainer" :autoPlay="true" :infiniteScroll="true" :playSpeed="5000" :touchDrag="false" :wheelControl="false" :mouseDrag="false">
    <slide class="slide-background">
      <div class="videoContainer">
        <video autoplay="autoplay" muted="muted" loop="loop" class="video-slide">
          <source data-src="/videos/1.webm" type="video/mp4" src="/videos/1.webm">
        </video>
      </div>
      <div class="relative text-center lg:text-left">
        <h1
          class="text-white uppercase text-shadow text-4xl md:text-5xl lg:text-6xl font-bold mt-10 ml-0 px-12 lg:px-0 lg:mt-32 lg:ml-36"
        >
          {{ $t("homeView.slideshowOneTitle")}}<br/>
          {{ $t("homeView.slideshowOneTitleTwo")}}
        </h1>
        <p
          class="text-primar-400 text-xl leading-7 font-normal ml-0 lg:ml-36 mt-4"
           v-html="$t('homeView.slideshowOneText')"
        >
        </p>
        <a
          href="https://my.eronto.io/register"
          class="py-2 px-8 ml-0 mt-2 lg:ml-36 lg:mt-6 inline-block font-medium text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 text-base xl:text-base  rounded-md shadow focus:ring-offset-blue-200  cursor-pointer"
        >
          {{ $t("homeView.signUpNow")}}
        </a>
      </div>
    </slide>
    
    <slide class="slide-background">
      <div class="videoContainer">
        <video autoplay="autoplay" muted="muted" loop="loop" class="video-slide lazy">
          <source data-src="/videos/3.webm" type="video/mp4">
        </video>
      </div>
      <div class="relative text-center lg:text-left">
        <h1
          class="text-white uppercase text-shadow text-4xl md:text-5xl lg:text-6xl font-bold mt-10 ml-0 px-12 lg:px-0 lg:mt-32 lg:ml-36"
        >
          {{ $t("homeView.slideshowTwoTitle")}}<br/>
          {{ $t("homeView.slideshowTwoTitleTwo")}}
          
        </h1>
        <p
          class="text-primar-400 text-xl leading-7 font-normal ml-0 lg:ml-36 mt-4"
           v-html="$t('homeView.slideshowTwoText')"
        >
        </p>
        <a
          href="https://my.eronto.io/register"
          class="py-2 px-8 ml-0 mt-2 lg:ml-36 lg:mt-6 inline-block font-medium text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 text-base xl:text-base rounded-md shadow focus:ring-offset-blue-200  cursor-pointer"
        >
          {{ $t("homeView.slideshowOneText")}}
        </a>
      </div>
    </slide>
    <slide class="slide-background">
      <div id="videoContainerThirdSlide" class="videoContainer">
        <video autoplay="autoplay" muted="muted" loop="loop" class="video-slide lazy">
          <source data-src="/videos/2.webm" type="video/mp4">
        </video>
      </div>
      <div class="relative text-center lg:text-left">
        <h1
            class="text-white uppercase text-shadow text-4xl md:text-5xl lg:text-6xl font-bold mt-10 ml-0 px-12 lg:px-0 lg:mt-32 lg:ml-36"
          >
            <span class="md:block whitespace-nowrap"> {{ $t("homeView.slideshowThreeTitle")}}<br> {{ $t("homeView.slideshowThreeTitleTwo")}}</span>
          </h1>
          <p
            class="text-primar-400 text-xl leading-7 font-normal ml-0 lg:ml-36 mt-4"
            v-html="$t('homeView.slideshowThreeText')"
          >
          </p>
          <a
            href="https://my.eronto.io/register"
            class="py-2 px-8 ml-0 mt-2 lg:ml-36 lg:mt-6 inline-block font-medium text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 text-base xl:text-base rounded-md shadow focus:ring-offset-blue-200  cursor-pointer"
          >
            {{ $t("homeView.joinNow")}}
          </a>
      </div>
    </slide>
    <slide class="slide-background">
      <div class="videoContainer">
        <video autoplay="autoplay" muted="muted" loop="loop" class="video-slide lazy">
          <source data-src="/videos/4.webm" type="video/mp4">
        </video>
      </div>
      <div class="relative text-center lg:text-left">
        <h1
            class="text-white uppercase text-shadow text-4xl md:text-5xl lg:text-6xl font-bold mt-10 ml-0 px-12 lg:px-0 lg:mt-32 lg:ml-36"
          >
            <span class="md:block whitespace-nowrap"> {{ $t("homeView.slideshowFourTitle")}}</span>
          </h1>
          <p
            class="text-primar-400 text-xl leading-7 font-normal ml-0 lg:ml-36 mt-4"
            v-html="$t('homeView.slideshowFourText')"
          >
          </p>
          <a
            href="https://my.eronto.io/register"
            class="py-2 px-8 ml-0 mt-2 lg:ml-36 lg:mt-6 inline-block font-medium text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 text-base xl:text-base rounded-md shadow focus:ring-offset-blue-200  cursor-pointer"
          >
            {{ $t("homeView.joinNow")}}
          </a>
      </div>
    </slide>
  </hooper>
  </template>
    
<script>
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation
  } from 'hooper';
  import 'hooper/dist/hooper.css';
export default {
      name: 'Slider',
      components: {
    Hooper,
    Slide,
    HooperNavigation
  },
      data() {
        return {
          timer: null,
          currentIndex: 0,
        }
      },
        mounted: function () {
          this.$nextTick(function () {
            this.loaded = true;
            setTimeout(function(){
            var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
              if ("IntersectionObserver" in window) {
                  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
                  entries.forEach(function(video) {
                      if (video.isIntersecting) {
                      for (var source in video.target.children) {
                          var videoSource = video.target.children[source];
                          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                          videoSource.src = videoSource.dataset.src;
                          }
                      }

                      video.target.load();
                      video.target.classList.remove("lazy");
                      lazyVideoObserver.unobserve(video.target);
                      }
                  });
                  });

                  lazyVideos.forEach(function(lazyVideo) {
                  lazyVideoObserver.observe(lazyVideo);
                  });
              }
            }, 3000);
          });
          this.startSlide();
        },
        methods: {
          startSlide: function() {
            this.timer = setInterval(this.next, 4000);
          },
          next: function() {
            this.currentIndex += 1
          },
          prev: function() {
            this.currentIndex -= 1
          }
        },
      
        computed: {

        }
      
    }
    </script>

<style scoped>

.videoContainer {
    height: 0;
    
    padding-top: 38%;
    position: absolute;
    width: 100%;
}

#videoContainerThirdSlide {
  padding-top: 40%;
}



.video-slide {
    display: inline-block;
    max-width: 100%;
    min-width: 100%;
    
    position: absolute;
    top: 50%;
    transform: translate(0%,-50%);
    vertical-align: top;
    -o-object-fit: none;
    object-fit: none;
    height: 440px;
}
.slide-background {
  background-position: right center; background-repeat: no-repeat; background-size: auto;
}

#hooperContainer {
  height: 300px;
}

@media only screen and (min-width: 1024px) {
  #hooperContainer {
    height: 583px;
  }

  .videoContainer {
    padding-top: 40%;
  }

  #videoContainerThirdSlide {
    padding-top: 38%;
  }

  .video-slide {
    -o-object-fit: cover;
    object-fit: cover;
    height: 100%;
  }
}
</style>